const TRANSLATION = {
  buyModal: {
    afterFree: 'หลังจากการทดลองใช้ฟรีของคุณ',
    btn: 'ลองฟรี',
    freeTrial: 'ทดลองใช้ฟรี 3 วัน',
    monthLabel: 'เดือน',
    selectLabel: 'เลือกแผน',
    title: 'แผนการสมัครสมาชิก',
    yearLabel: 'ปี',
  },
  contact: {
    block1:
      'สำหรับการปรับแต่ง คำถาม หรือข้อเสนอแนะ โปรดติดต่อเราที่ contact@noam.tools เราจะตอบกลับทันที',
    block2: 'สนับสนุนเราโดยการให้คะแนนเราในร้านค้าส่วนขยายของ Google Apps ที่ ★★★★★',
    block3: 'ช่วยเหลือผู้อื่นด้วยการแชร์ส่วนขยายนี้:',
    title: 'ติดต่อเรา',
  },
  help: {
    AquickOverviewOfNoam: 'ภาพรวมโดยย่อของโนม',
    ChatPDF: 'แชท PDF',
    ChatPDF2: 'แชทPDF',
    FavoritesManagement: 'การจัดการรายการโปรด',
    Fixedplugin: 'ปลั๊กอินคงที่',
    Focusing: 'การมุ่งเน้น',
    Free: 'ฟรี',
    FreeTrialBenefits: 'สิทธิประโยชน์การทดลองใช้ฟรี',
    GoWithWikipedia: 'ไปกับวิกิพีเดีย',
    GoWithYouTube: 'ไปกับยูทูป',
    HoverTranslation: 'โฮเวอร์แปล',
    Howtouse: 'วิธีใช้',
    ImageTranslation: 'การแปลรูปภาพ',
    InstantTranslation: 'การแปลทันที',
    Membership: 'สมาชิกภาพ',
    NoamHelp: 'Noam ช่วยคุณแปลและสรุป',
    PDFparallelTranslation: 'การแปล PDF แบบขนาน',
    ParallelTranslation: 'การแปลแบบขนาน',
    SkipAllSteps: 'ข้ามขั้นตอนทั้งหมด',
    Summary: 'สรุป',
    Translation: 'การแปล',
    TryItForFree: 'ทดลองใช้ฟรี',
    Video: 'วีดีโอ',
    VideoSummary: 'สรุปวิดีโอ',
    VideoTranslation: 'การแปลวิดีโอ',
    WebSummary: 'สรุปเว็บ',
    WordSelectionTranslation: 'การแปลการเลือกคำ',
    benefits: 'เรามีสิทธิประโยชน์รอคุณอยู่!',
    dayFree: 'ทดลองใช้ฟรี 3 วัน',
    done: 'เสร็จแล้ว',
    next: 'ต่อไป',
    pin: 'Pin Noam เพื่อการเข้าถึงที่ง่ายขึ้น ~~~',
    planIsNotExist: 'ไม่มีแผนให้บริการ',
    startWiki: 'เริ่มจากวิกิมีเดียกันเถอะ!',
    startYoutube: 'มาเริ่มกันที่ YouTube!',
    try: 'ลองดูสิ',
    tryNow: 'ให้มันลองตอนนี้!',
  },
  home: {
    PDFTranslate: {
      desc: 'การแปลสองภาษา + แชท PDF',
      sub1: {
        desc: 'การอ่านสองภาษาช่วยให้คุณเปรียบเทียบข้อความต้นฉบับและการแปลแบบเคียงข้างกัน ซึ่งช่วยเพิ่มประสิทธิภาพในการอ่าน',
        title: 'การอ่านสองภาษา',
      },
      sub2: { desc: 'AI วิเคราะห์และสรุป และสามารถตอบคำถามของคุณตามเนื้อหา PDF', title: 'แชท PDF' },
      sub3: {
        desc: 'การแปล PDF ที่ขับเคลื่อนด้วย AI เพื่อความแม่นยำและประสิทธิภาพที่มากขึ้น',
        title: 'ความแม่นยำและประสิทธิภาพ',
      },
      title: 'แปล PDF',
    },
    aiAssistant: {
      desc: 'ทำให้การแปลเว็บฉลาดขึ้นและสะดวกยิ่งขึ้น',
      panel1: {
        desc: 'การแปลแบบอ้างอิงโยงสองภาษาช่วยให้คุณเปรียบเทียบข้อความต้นฉบับกับคำแปล เพื่อให้คุณสามารถเข้าใจได้ดีขึ้นและปรับปรุงประสิทธิภาพการอ่านของคุณ',
        title: 'การแปลสองภาษา',
      },
      panel2: {
        left: {
          desc: 'เมื่อเรียกดูหน้าเว็บ ให้วางเมาส์เหนือเนื้อหาที่คุณต้องการแปลเพื่อดูคำแปล',
          title: 'โฮเวอร์แปล',
        },
        right: {
          desc: 'เมื่อเรียกดูหน้าเว็บ ให้เลือกข้อความที่คุณต้องการแปลเพื่อดูคำแปล',
          title: 'การแปลการเลือกข้อความ',
        },
      },
      panel3: {
        one: {
          desc: 'แปลและสรุปหน้าเว็บและเนื้อหาวิดีโอได้ทุกที่ทุกเวลาเพื่อประสบการณ์ที่ราบรื่นยิ่งขึ้น!',
          title: 'ชี้และคลิก',
        },
        three: {
          desc: 'โมเดลภาษาขนาดใหญ่ที่ขับเคลื่อนด้วย AI ช่วยให้มั่นใจในความแม่นยำและความสม่ำเสมอในการแปลเพื่อประสบการณ์การอ่านที่ดียิ่งขึ้น',
          title: 'ขับเคลื่อนด้วย AI',
        },
        two: {
          desc: 'ครอบคลุมหลายภาษา การอ่านสองภาษาแบบไร้อุปสรรค การแปลด้วยคลิกเดียว - สัมผัสกับความแตกต่าง!',
          title: 'ครอบคลุมและสะดวกยิ่งขึ้น',
        },
      },
      panel4: {
        tab1: {
          desc: 'ผู้เชี่ยวชาญด้านประสิทธิภาพของคุณ - ใช้ ChatGPT, Noam แปลและสรุปเนื้อหาวิดีโอ YouTube เพื่อช่วยคุณประหยัดเวลา!',
          key: 'วีดีโอ',
          title: 'การแปลวิดีโอและสรุป',
        },
        tab2: { desc: 'คลิกเพื่อแปลภาพขณะท่องเว็บ', key: 'ภาพ', title: 'แปลรูปภาพ' },
        tab3: {
          desc: 'ดึงข้อมูลสำคัญจากหน้าเว็บทันทีและให้ข้อมูลสรุป ซึ่งจะช่วยเพิ่มประสิทธิภาพในการอ่านของคุณ',
          key: 'เว็บ',
          title: 'แปลเว็บและสรุป',
        },
        tag1: 'เรียบง่าย',
        tag2: 'มีประสิทธิภาพ',
        tag3: 'เข้าใจง่าย',
      },
      title: 'ผู้ช่วยเอไอ',
    },
    getStart: 'เริ่มต้นเลย',
    getStartedForFree: 'เริ่มต้นได้ฟรี',
    howItWork: {
      desc: 'Noam ผสานรวมโมเดล AI เพื่อมอบประสบการณ์อัจฉริยะแก่ผู้ใช้ในการแปลและการสรุปหน้าเว็บข้ามภาษา การแปล PDF และรูปภาพ การแปลและการสรุปวิดีโอ',
      title: 'มันทำงานอย่างไร',
    },
    lastBlock: { desc: 'การแปล AI ที่ดีขึ้นเพื่อประสบการณ์การอ่านที่ราบรื่นยิ่งขึ้น' },
    top: {
      desc: 'Noam เป็นส่วนขยายเบราว์เซอร์ AI ฟรีที่ช่วยคุณแปลและสรุปหน้าเว็บ วิดีโอ และเนื้อหา PDF\\n เข้าร่วม Noam และสัมผัสประสบการณ์มหัศจรรย์!',
      title1: 'หนึ่งเวทย์มนตร์',
      title2: 'คลิกเดียว',
    },
    userReviews: { desc: 'บทวิจารณ์ระดับห้าดาวบน Chrome เว็บสโตร์', title: 'รีวิวจากผู้ใช้' },
  },
  installTips: {
    btn: 'ลองเลย',
    text: 'ติดตั้ง "ปลั๊กอินเบราว์เซอร์ Noam" เพื่อปลดล็อกคุณสมบัติเพิ่มเติม! การอ้างอิงโยงเว็บ\\nการสรุปวิดีโอบนเว็บ และอื่นๆ อีกมากมาย!',
  },
  locale: {
    af: 'ชาวแอฟริกัน',
    am: 'อัมฮาริก',
    ar: 'ภาษาอาหรับ',
    as: 'อัสสัม',
    auto: 'ตรวจจับอัตโนมัติ',
    az: 'อาเซอร์ไบจัน',
    ba: 'บัชคีร์',
    bg: 'บัลแกเรีย',
    bn: 'บางลา',
    bo: 'ทิเบต',
    bs: 'บอสเนีย',
    ca: 'คาตาลัน',
    cs: 'เช็ก',
    cy: 'เวลส์',
    da: 'ภาษาเดนมาร์ก',
    de: 'เยอรมัน',
    dsb: 'ซอร์เบียตอนล่าง',
    dv: 'ดิวิหิ',
    el: 'กรีก',
    en: 'ภาษาอังกฤษ',
    es: 'สเปน',
    et: 'เอสโตเนีย',
    eu: 'บาสก์',
    fa: 'เปอร์เซีย',
    fi: 'ภาษาฟินแลนด์',
    fil: 'ฟิลิปปินส์',
    fj: 'ฟิจิ',
    fr: 'ภาษาฝรั่งเศส',
    frCA: 'ฝรั่งเศส (แคนาดา)',
    ga: 'ไอริช',
    gl: 'กาลิเซีย',
    gom: 'กอนกานี',
    gu: 'คุชราต',
    ha: 'เฮาซา',
    he: 'ภาษาฮีบรู',
    hi: 'ฮินดี',
    hr: 'โครเอเชีย',
    hsb: 'ซอร์เบียนตอนบน',
    ht: 'ชาวเฮติครีโอล',
    hu: 'ภาษาฮังการี',
    hy: 'อาร์เมเนีย',
    id: 'ชาวอินโดนีเซีย',
    ig: 'อิกโบ',
    ikt: 'อินุอินนักตุน',
    is: 'ไอซ์แลนด์',
    it: 'ภาษาอิตาลี',
    iu: 'อินุกติตุต',
    iuLatn: 'อินุกติตุต (ละติน)',
    ja: 'ญี่ปุ่น',
    ka: 'จอร์เจีย',
    kk: 'คาซัค',
    km: 'เขมร',
    kmr: 'เคิร์ด (ภาคเหนือ)',
    kn: 'กันนาดา',
    ko: 'เกาหลี',
    ku: 'เคิร์ด (กลาง)',
    ky: 'คีร์กีซ',
    ln: 'ลิงกาลา',
    lo: 'ลาว',
    lt: 'ลิทัวเนีย',
    lug: 'กานดา',
    lv: 'ลัตเวีย',
    lzh: 'จีน (วรรณกรรม)',
    mai: 'ไมถิลี',
    mg: 'มาลากาซี',
    mi: 'เมารี',
    mk: 'มาซิโดเนีย',
    ml: 'มาลายาลัม',
    mnCyrl: 'มองโกเลีย (ซีริลลิก)',
    mnMong: 'มองโกเลีย (ดั้งเดิม)',
    mr: 'ภาษามราฐี',
    ms: 'มาเลย์',
    mt: 'ภาษามอลตา',
    mww: 'ม้งดาว',
    my: 'เมียนมาร์ (พม่า)',
    nb: 'ภาษานอร์เวย์',
    ne: 'เนปาล',
    nl: 'ภาษาดัตช์',
    noSearchLang: 'ไม่รองรับภาษา',
    nso: 'เซโซโท ซา เลบัว',
    nya: 'เนียนจา',
    or: 'โอเดีย',
    otq: 'เกเรตาโร โอโตมิ',
    pa: 'ปัญจาบ',
    pl: 'ขัด',
    placeholder: 'ค้นหา',
    prs: 'ดาริ',
    ps: 'ปาสโต้',
    pt: 'โปรตุเกส (บราซิล)',
    ptPT: 'โปรตุเกส (โปรตุเกส)',
    ro: 'โรมาเนีย',
    ru: 'ภาษารัสเซีย',
    run: 'รันดี',
    rw: 'กินยาวันดา',
    sd: 'สินธี',
    si: 'สิงหล',
    sk: 'สโลวัก',
    sl: 'ภาษาสโลเวเนีย',
    sm: 'ซามัว',
    sn: 'โชนา',
    so: 'โซมาเลีย',
    sq: 'แอลเบเนีย',
    srCyrl: 'เซอร์เบีย (ซีริลลิก)',
    srLatn: 'เซอร์เบีย (ละติน)',
    st: 'เซโซโท',
    sv: 'ภาษาสวีเดน',
    sw: 'สวาฮีลี',
    ta: 'ทมิฬ',
    te: 'เตลูกู',
    th: 'แบบไทย',
    ti: 'ทิกริญญา',
    tk: 'เติร์กเมนิสถาน',
    tlhLatn: 'คลิงออน (ละติน)',
    tlhPiqd: 'คลิงออน (pIqaD)',
    tn: 'เซทสวานา',
    to: 'ตองกา',
    tr: 'ภาษาตุรกี',
    tt: 'ตาตาร์',
    ty: 'ตาฮิติ',
    ug: 'ชาวอุยกูร์',
    uk: 'ภาษายูเครน',
    ur: 'ภาษาอูรดู',
    uz: 'อุซเบก (ละติน)',
    vi: 'ภาษาเวียดนาม',
    xh: 'โคซา',
    yo: 'โยรูบา',
    yua: 'ยูคาเทค มายา',
    yue: 'กวางตุ้ง (ดั้งเดิม)',
    zh: 'ชาวจีน',
    zhHans: 'จีนตัวย่อ',
    zhHant: 'จีนดั้งเดิม',
    zu: 'ซูลู',
  },
  login: {
    and: 'และ',
    btn: 'เข้าสู่ระบบด้วย Google',
    btn1: 'เข้าสู่ระบบตอนนี้',
    desc: 'เข้าสู่ระบบเพื่อปลดล็อคประสบการณ์เพิ่มเติม',
    policy: 'นโยบายความเป็นส่วนตัว',
    terms: 'เงื่อนไขการใช้งาน',
    tips: 'ในการสมัคร ฉันยอมรับ',
    title: 'ยินดีต้อนรับสู่โนอัม',
  },
  pageFooter: {
    follow: { facebook: 'เฟสบุ๊ค', title: 'ติดตาม', twitter: 'ทวิตเตอร์' },
    legal: { policy: 'นโยบายความเป็นส่วนตัว', terms: 'ข้อกำหนดในการให้บริการ', title: 'ถูกกฎหมาย' },
    product: {
      image: 'การแปลรูปภาพ',
      pdf: 'การแปล PDF',
      title: 'สินค้า',
      video: 'การแปลวิดีโอและสรุป',
      web: 'การแปลเว็บและสรุป',
    },
    resources: { title: 'ทรัพยากร' },
  },
  pageHeader: {
    contact: 'ติดต่อ',
    help: 'ช่วย',
    logout: 'ออกจากระบบ',
    logoutSucc: 'ออกจากระบบแล้ว',
    pricing: 'ราคา',
    settings: 'การตั้งค่า',
    signUp: 'เข้าสู่ระบบ',
  },
  pdf: {
    autoDetect: 'ตรวจจับอัตโนมัติ',
    cancelBtn: 'ยกเลิก',
    cancelUpload: 'ยกเลิก',
    chatPdf: {
      Search: 'ค้นหา',
      cancel: 'ยกเลิก',
      chatTitle: 'ยินดีต้อนรับสู่โนม! นี่คือบทสรุปของ PDF ของคุณ:',
      clear: 'ชัดเจน',
      clearContent: 'นี่จะเป็นการเริ่มการสนทนาใหม่ การสนทนาปัจจุบันจะไม่ถูกบันทึก คุณแน่ใจเหรอ?',
      clearDialogTitle: 'กรุณายืนยัน',
      clearSucc: 'เคลียร์แล้ว',
      copy: 'สำเนา',
      copySucc: 'คัดลอกแล้ว',
      delete: 'ลบ',
      deleteCancel: 'ยกเลิก',
      deleteContent: 'PDF นี้ไม่สามารถกู้คืนได้เมื่อถูกลบแล้ว คุณแน่ใจเหรอ?',
      deleteOk: 'ลบ',
      deleteSuccess: 'ลบแล้ว',
      deleteTitle: 'ยืนยันการลบ',
      expand: 'ทรุด',
      historyTitle: 'ประวัติศาสตร์',
      listError: 'ไม่สามารถโหลดรายการเรื่องรออ่าน โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
      loading: 'กำลังโหลด...',
      noDataDesc: 'ยังไม่มีประวัติ',
      noMore: 'ไม่มีเนื้อหาอีกต่อไป',
      placeholder: 'ถามอะไรเกี่ยวกับ PDF นี้',
      summaryTitle: 'คุณอาจสนใจคำถามเหล่านี้:',
    },
    collectionEmpty: 'คอลเลกชันของคุณว่างเปล่า',
    collectionTab: 'หมายเหตุ',
    dataLoading: 'กำลังโหลด...',
    dialogContent: 'คุณแน่ใจหรือไม่ว่าต้องการลบสิ่งนี้',
    dialogTitle: 'กรุณายืนยัน',
    download: {
      both: 'สองภาษา',
      btn: 'บันทึก',
      cancel: 'การปิดหน้าต่างนี้จะยกเลิกการดาวน์โหลดไฟล์ PDF คุณแน่ใจหรือไม่ว่าต้องการยกเลิก',
      desc: 'บันทึกลงอุปกรณ์: ดาวน์โหลดคำแปลเป็นรูปภาพ บันทึกและพิมพ์: ดาวน์โหลดคำแปลในรูปแบบต้นฉบับ พร้อมรองรับการคัดลอก',
      download: 'ดาวน์โหลด',
      downloadMsg1: 'ความคืบหน้าการแปล PDF:',
      downloadMsg2: 'เวลาที่เหลืออยู่โดยประมาณ:',
      downloadSucc: 'PDF พร้อมแล้ว! คลิกเพื่อบันทึก',
      downloadTip:
        'กำลังดาวน์โหลดไฟล์ PDF อย่าปิดหน้าต่างนี้เพื่อหลีกเลี่ยงข้อผิดพลาดในการดาวน์โหลด',
      error: 'บันทึกไม่สำเร็จ ลองพิมพ์แทน',
      fileName: 'ชื่อไฟล์:',
      fileType: 'ประเภทไฟล์:',
      loading: 'ประหยัด...',
      loading2: 'กำลังโหลด...',
      minute: 'นาที...',
      msg1: 'คำแปลบางส่วนในเอกสารนี้ยาวกว่าข้อความต้นฉบับ และอาจทับซ้อนในไฟล์ที่ดาวน์โหลด เราแนะนำให้อ่านบนหน้าเว็บ',
      msg2: '1. การแปลยังไม่เสร็จสมบูรณ์ กรุณาดาวน์โหลดหลังจากการแปลเสร็จสิ้น',
      msg3: '2. คำแปลบางคำยาวเกินไป อ่านบนหน้าเว็บเพื่อหลีกเลี่ยงการทับซ้อนข้อความ',
      msg4: 'งานแปลอยู่ในระหว่างดำเนินการ โปรดลองอีกครั้งหลังจากเสร็จสิ้น',
      progress:
        'การแปล PDF ความคืบหน้า: {{progress}} เวลาที่เหลืออยู่โดยประมาณ: {{ minutes}} นาที...',
      save: 'บันทึกลงในอุปกรณ์',
      savePrint: 'บันทึกและพิมพ์',
      success: 'ดาวน์โหลดแล้ว',
      trans: 'การแปลเท่านั้น',
      transContinue: 'แปลต่อ',
    },
    downloadBtn: 'ดาวน์โหลด',
    dragTipModal: {
      black: 'ช่องว่าง',
      leftKey: 'ปุ่มซ้าย',
      ok: 'เข้าใจแล้ว',
      press: 'กด',
      tips: 'เพื่อลากและดู',
    },
    entry: 'PDF',
    fileErrMsg: 'การอ่านไฟล์ล้มเหลว โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    fileMsg: 'ขนาดไฟล์ปัจจุบัน:',
    fileMsg2: 'โปรดอัปโหลดไฟล์ที่มีขนาดเล็กกว่า 300MB',
    freeBannerBtn: 'อัพเกรด',
    freeBannerTips: 'ถึงขีดจำกัดการแปล PDF ฟรีแล้ว',
    guide: {
      placeholder: 'วางลิงก์ PDF ที่นี่',
      start: 'เริ่มการแปล',
      text1: 'การอ่านสองภาษา',
      text2:
        'อ่านสองภาษาเพื่อเปรียบเทียบข้อความต้นฉบับและการแปลเคียงข้างกัน เพื่อปรับปรุงประสิทธิภาพของคุณ',
      text3: 'แชทด้วย PDF ของคุณ',
      text4:
        'การวิเคราะห์และการสรุปที่ขับเคลื่อนด้วย AI ถามคำถามเกี่ยวกับ PDF ของคุณและรับคำตอบทันที',
      text5: 'แม่นยำและมีประสิทธิภาพ',
      text6: 'การแปล PDF ที่ขับเคลื่อนด้วย AI เพื่อความแม่นยำและประสิทธิภาพที่มากขึ้น',
      title1: 'การแปลสองภาษา',
      title2: 'แชทด้วย PDF ของคุณ',
      toast: 'โปรดป้อนลิงก์ PDF ออนไลน์ที่ถูกต้องซึ่งลงท้ายด้วย .pdf',
    },
    hasTransTask: 'งานแปลอยู่ระหว่างดำเนินการ โปรดรอ.',
    hoverTrans: 'เลื่อนย่อหน้าเพื่อแปล',
    initial: 'แปล PDF',
    installText: 'โซลูชันครบวงจรสำหรับการแปลทุกวัน',
    installText2: 'กรุณาติดตั้งส่วนขยายก่อน',
    installTips: 'ติดตั้งส่วนขยายเพื่อการแปล PDF มากขึ้นและการแปลเว็บไซต์ที่ราบรื่นยิ่งขึ้น:',
    kw: 'แก่น',
    link: 'ลิงค์',
    listError: 'โหลด PDF ไม่สำเร็จ โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    memoTotalCount: 'ทั้งหมด 1 รายการ',
    new: 'ไฟล์ใหม่',
    noId: 'ไม่พบรหัสไฟล์',
    notPdf: 'ไฟล์ PDF เท่านั้น',
    okBtn: 'ลบ',
    okBtn2: 'เข้าใจแล้ว',
    original: 'ต้นฉบับ',
    parallel: 'ขนาน',
    parseErrDialogContent:
      'ลิงก์ PDF นี้ไม่สามารถแปลได้โดยตรง โปรดดาวน์โหลดไฟล์ PDF และอัปโหลดเพื่อการแปล',
    parseErrTips: 'แยกวิเคราะห์ไฟล์ไม่สำเร็จ',
    parseFileToast: 'แยกวิเคราะห์ไฟล์ไม่สำเร็จ โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    pdfLoading: 'กำลังแยกวิเคราะห์...',
    searchPlaceholder: 'ค้นหา',
    selectTrans: 'เลือกข้อความที่จะแปล',
    shareBtn: 'แบ่งปัน',
    shareBtnText1: 'สร้างแชร์ลิงก์',
    shareBtnText2: 'อัปเดตเนื้อหาที่แชร์',
    shareModal: {
      cancel: 'ยกเลิก',
      copy: 'สำเนา',
      copySucc: 'คัดลอกลิงก์แล้ว',
      custom: 'ปรับแต่ง:',
      errMsg: 'เนื้อหาที่เลือกยังไม่ได้รับการแปลโดยสมบูรณ์ กรุณาแปลก่อนแชร์',
      gen: 'แบ่งปัน',
      modify: 'แก้ไข',
      notSupport: 'ขณะนี้ยังไม่รองรับภาษานี้',
      page: 'หน้า',
      pageNuErr: 'กรุณากรอกหมายเลขหน้าที่ถูกต้อง',
      range: 'ขอบเขต:',
      remain: 'ที่เหลืออยู่',
      remain1: 'เวลาโดยประมาณทั้งหมด:',
      search: 'ค้นหา',
      settings: 'การตั้งค่าการแชร์:',
      shareSetting: 'แบ่งปันการตั้งค่า',
      shareText: 'แบ่งปัน',
      shareTips: 'แชร์ลิงก์ PDF ที่แปลแล้วกับเพื่อนของคุณ:',
      sourceLang: 'จาก:',
      target: 'ถึง:',
      text1: 'แบ่งปันการตั้งค่า',
      text2: 'สร้างแชร์ลิงก์',
      totalPage: 'ทั้งหมด 1 หน้า',
      trans: 'แปล',
      translateTips: 'เคล็ดลับ: หากการแปลใช้เวลาสักครู่ คุณสามารถปิดหน้าต่างนี้และแชร์ในภายหลังได้',
      translating: 'กำลังแปล PDF...',
      update: 'อัปเดตแชร์ลิงก์',
    },
    shareMsg1: 'สร้างลิงก์แชร์แล้ว',
    shareMsg2: 'อัปเดตเนื้อหาที่แชร์แล้ว',
    shareMsg3: 'ไม่สามารถสร้างลิงก์แชร์ได้ โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    shareMsg4: 'ไม่สามารถอัปเดตเนื้อหาที่แชร์ได้ โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    shareTips: 'การแปล PDF ของคุณพร้อมแล้ว! แบ่งปันกับเพื่อนของคุณ',
    start: 'เริ่มทดลองใช้ฟรีของคุณ',
    thumbnail: 'สารบัญ',
    toast1: 'กำลังโหลด PDF โปรดลองอีกครั้งในภายหลัง',
    toast2: 'เนื้อหา PDF มีขนาดใหญ่เกินไป ขณะนี้ระบบไม่รองรับกล่องโต้ตอบ',
    toast3: 'กำลังดาวน์โหลด โปรดลองอีกครั้งหลังจากการดาวน์โหลดเสร็จสิ้น',
    toolbar: { Adjust: 'ปรับ', autoFit: 'ปรับพอดีอัตโนมัติ' },
    trans: 'การแปล',
    transSucc: 'แปลสำเร็จ!',
    unLoginToast: 'กรุณาเข้าสู่ระบบเพื่อใช้คุณสมบัตินี้',
    uploadBtn: 'อัปโหลด',
    uploadErr: 'การอัปโหลดไฟล์ล้มเหลว โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    uploadMsg1: 'ลากและวางไฟล์ของคุณที่นี่',
    uploadMsg2: 'ประเภทไฟล์ที่รองรับ: PDF |  ขนาดไฟล์สูงสุด: 100MB',
    uploadMsg3: 'คลิกเพื่อเลือกหรือลากและวางไฟล์ที่นี่',
    uploading: 'กำลังอัพโหลด',
    uploadingMsg: 'กำลังอัพโหลด โปรดรอ.',
    uploadingMsg1: 'กำลังอัปโหลดไฟล์ โปรดลองอีกครั้งในภายหลัง',
    uploadingMsg2: 'ขณะนี้ไฟล์กำลังถูกแปลง โปรดลองอีกครั้งในภายหลัง',
    uploadingMsg3: 'คำขอความคืบหน้าในการแปลงล้มเหลว โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    uploadingMsg4: 'Noam ไม่สามารถเข้าถึงไฟล์ในเครื่อง โปรดอัปโหลด PDF เพื่อการแปลด้วยตนเอง',
    uploadingMsg5:
      'ไม่สามารถเรียกข้อมูล URL ของไฟล์ โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายสนับสนุน',
    video: 'วิดีโอ',
    vipBannerBtn: 'อัพเกรด',
    vipBannerTips: 'คุณได้แปล PDF ถึงขีดจำกัดสำหรับเดือนนี้แล้ว',
    webTrans: 'การอ้างอิงโยงแบบเต็ม',
  },
  pricing: {
    FAQ: 'คำถามที่พบบ่อย',
    FQAObj: {
      a1: 'ใช่ Noam เสนอแผนฟรีที่คุณสามารถใช้ได้ทันที',
      a2: 'เราเสนอแผนการเป็นสมาชิกสามแบบ: Pro, Pro+ และ Enterprise คุณสามารถเลือกชำระรายเดือนหรือรายปีได้ การเรียกเก็บเงินรายปีช่วยประหยัดได้มาก',
      a3: 'คุณสมบัติทั้งหมดมีอยู่ในทั้งสองแผน ความแตกต่างที่สำคัญคือค่าใช้จ่าย: การสมัครสมาชิกรายปีมีค่าใช้จ่ายโดยรวมน้อยกว่า การสมัครสมาชิกรายเดือนจะถูกเรียกเก็บเงินในแต่ละเดือน ในขณะที่แผนรายปีจะถูกเรียกเก็บเงินปีละครั้ง',
      a4: 'คุณสามารถยกเลิกการสมัครสมาชิกของคุณได้ตลอดเวลาในการตั้งค่าบัญชีของคุณ',
      q1: 'มีแผนฟรีหรือไม่?',
      q2: 'มีแผนราคาและตัวเลือกการชำระเงินอะไรบ้าง?',
      q3: 'การสมัครรายเดือนกับรายปีแตกต่างกันอย่างไร?',
      q4: 'ฉันจะยกเลิกการสมัครสมาชิกของฉันได้อย่างไร?',
    },
    around: 'รอบๆ',
    billedMonthly: 'เรียกเก็บเงินรายเดือน',
    billedYearly: 'เรียกเก็บเงินเป็นรายปี',
    day: 'วัน',
    desc: 'เปรียบเทียบแผนและเลือกสิ่งที่ดีที่สุด',
    detailedCompare: 'เปรียบเทียบแผน',
    discount: 'ลด 20%',
    enterprise: {
      benefit1: 'การสนับสนุนลูกค้าลำดับความสำคัญ',
      benefit2: 'ผู้ใช้หลายคน',
      benefit3: 'โซลูชั่นที่ปรับให้เหมาะสม',
      benefit5: 'ผู้จัดการบัญชีเฉพาะ',
      btn: 'ติดต่อเรา',
      recommendText: 'แผนแบบกำหนดเอง (≥3คน)',
      talkToUs: 'ได้รับการติดต่อ',
    },
    free: {
      benefit1: 'แปลทันที 100 ครั้ง/วัน',
      benefit2: 'การแปลเว็บไซต์ & สรุป',
      benefit3: '30 การแปลรูปภาพ',
      benefit4: 'การแปลวิดีโอและสรุป',
      benefit5: '10 การแปล PDF',
      benefit6: '5,000 โทเค็น',
      btn: 'ลองฟรี',
      recommendText: 'ทดลองใช้ฟรี',
    },
    imageTranslation: 'การแปลรูปภาพ',
    month: 'เดือน',
    monthly: 'รายเดือน',
    pageTitle: 'ราคา',
    pdf: {
      chat: 'แบบสอบถามการแชท PDF',
      maxPage: 'สูงสุด จำนวนหน้าต่อ PDF',
      translation: 'การแปล PDF',
    },
    preMonth: 'ต่อเดือน',
    pro: {
      benefit1: 'การสนับสนุนลูกค้าลำดับความสำคัญ',
      benefit2: '1,000,000 โทเค็น/เดือน',
      benefit3: 'การแปลเว็บไซต์ & สรุป',
      benefit4: '200 การแปลรูปภาพ',
      benefit5: 'การแปลวิดีโอและสรุป',
      benefit6: 'การแปล PDF 200 รายการ',
      btn: 'เริ่มต้นเลย',
      recommendText: 'ยอดนิยมที่สุด',
    },
    proPlus: {
      benefit1: 'การสนับสนุนลูกค้าลำดับความสำคัญ',
      benefit2: '3,000,000 โทเค็น/เดือน',
      benefit3: 'การแปลเว็บไซต์ & สรุป',
      benefit4: '500 การแปลรูปภาพ',
      benefit5: 'การแปลวิดีโอและสรุป',
      benefit6: 'การแปล PDF 500 รายการ',
      recommendText: 'คุ้มค่าที่สุด',
    },
    video: { summary: 'สรุปวิดีโอ', translation: 'การแปลวิดีโอ' },
    web: {
      contrastiveTranslation: 'การแปลสองภาษา',
      dictionaryTranslation: 'การแปลการคัดเลือก',
      hoverTranslation: 'โฮเวอร์แปล',
      instantTranslation: 'การแปลทันที',
      summary: 'สรุปหน้าเว็บ',
    },
    yearly: 'เป็นประจำทุกปี',
  },
  privacy: {
    block1:
      'Noam ("Noam" "เรา" "ของเรา" หรือ "พวกเรา") เคารพความเป็นส่วนตัวของคุณและมุ่งมั่นที่จะปกป้องข้อมูลใด ๆ ที่เราได้รับจากคุณหรือเกี่ยวกับคุณ นโยบายความเป็นส่วนตัวนี้อธิบายหลักปฏิบัติของเราเกี่ยวกับการรวบรวมหรือการใช้ข้อมูลส่วนบุคคลจากการใช้งานเว็บไซต์ แอปพลิเคชัน และบริการของเรา (เรียกรวมกันว่า "บริการ") นโยบายความเป็นส่วนตัวนี้ใช้ไม่ได้กับเนื้อหาที่เราจัดการในนามของลูกค้าผลิตภัณฑ์ทางธุรกิจของเรา เช่น API ของเรา การใช้ข้อมูลนี้อยู่ภายใต้ข้อตกลงของลูกค้า ซึ่งครอบคลุมถึงการเข้าถึงและการใช้ผลิตภัณฑ์เหล่านี้',
    block10:
      'เราใช้มาตรการด้านเทคนิค การบริหาร และองค์กรที่สมเหตุสมผลในเชิงพาณิชย์เพื่อปกป้องข้อมูลส่วนบุคคลทางออนไลน์และออฟไลน์จากการสูญหาย การใช้ในทางที่ผิด และการเข้าถึง การเปิดเผย การเปลี่ยนแปลง หรือการกระทำที่ไม่เป็นมิตรโดยไม่ได้รับอนุญาต อย่างไรก็ตาม ไม่มีการส่งอินเทอร์เน็ตหรืออีเมลใดที่สามารถรับประกันความปลอดภัยหรือความถูกต้องสมบูรณ์ได้ โดยเฉพาะอย่างยิ่ง อีเมลที่ส่งถึงเราหรือจากเราอาจไม่ปลอดภัย ดังนั้น คุณควรใช้ความระมัดระวังเป็นพิเศษในการตัดสินใจว่าจะส่งข้อมูลใดให้เราผ่านบริการหรืออีเมล นอกจากนี้ เราไม่รับผิดชอบต่อการขัดขวางการตั้งค่าความเป็นส่วนตัวหรือมาตรการรักษาความปลอดภัยในบริการหรือการตั้งค่าความปลอดภัยหรือมาตรการรักษาความปลอดภัยของเว็บไซต์บุคคลที่สาม เราจะเก็บรักษาข้อมูลส่วนบุคคลของคุณไว้นานเท่าที่จำเป็นเพื่อให้บริการแก่คุณหรือเพื่อวัตถุประสงค์ทางธุรกิจที่ชอบด้วยกฎหมายอื่น ๆ เช่น การแก้ไขข้อพิพาท เหตุผลด้านความปลอดภัยและความปลอดภัย หรือการปฏิบัติตามภาระผูกพันทางกฎหมายของเรา ระยะเวลาที่เราเก็บรักษาข้อมูลส่วนบุคคลจะขึ้นอยู่กับปัจจัยหลายประการ เช่น จำนวน ลักษณะ ความละเอียดอ่อนของข้อมูล ความเสี่ยงที่อาจเกิดขึ้นจากการใช้หรือการเปิดเผยโดยไม่ได้รับอนุญาต วัตถุประสงค์ที่เราประมวลผลข้อมูล และข้อพิจารณาอื่น ๆ ที่มีผลผูกพันทางกฎหมาย',
    block11:
      'เราอาจปรับปรุงนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว เมื่อเราทำเช่นนั้น เราจะโพสต์เวอร์ชันอัปเดตบนหน้านี้ เว้นแต่กฎหมายที่บังคับใช้จะกำหนดไว้เป็นอย่างอื่น',
    block12:
      'หากคุณมีคำถามที่ยังไม่ได้ตอบหรือข้อกังวลเกี่ยวกับนโยบายความเป็นส่วนตัวนี้ โปรดติดต่อฝ่ายบริการลูกค้าของเรา อีเมล:',
    block2: 'เราเก็บรวบรวมข้อมูลส่วนบุคคลต่อไปนี้ ("ข้อมูลส่วนบุคคล") ที่เกี่ยวข้องกับคุณ:',
    block3:
      'ข้อมูลที่คุณให้ไว้: เมื่อคุณสร้างบัญชีเพื่อใช้บริการของเราหรือสื่อสารกับเรา เราจะรวบรวมข้อมูลส่วนบุคคลดังต่อไปนี้:',
    block4:
      'ข้อมูลส่วนบุคคลที่ได้รับโดยอัตโนมัติจากการใช้บริการของคุณ: เมื่อคุณเข้าถึง ใช้ หรือโต้ตอบกับบริการ เราได้รับข้อมูลต่อไปนี้เกี่ยวกับการเข้าถึง การใช้งาน หรือการโต้ตอบของคุณ ("ข้อมูลทางเทคนิค"):',
    block5: 'เราอาจใช้ข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ดังต่อไปนี้:',
    block6:
      'ข้อมูลสรุปหรือข้อมูลที่ไม่ระบุตัวตน: เราอาจรวบรวมหรือลบการระบุข้อมูลส่วนบุคคลเพื่อป้องกันการใช้ซ้ำเพื่อวัตถุประสงค์ในการระบุตัวตน และใช้ข้อมูลดังกล่าวเพื่อวิเคราะห์ประสิทธิภาพของบริการของเรา ปรับปรุงและเพิ่มคุณสมบัติในบริการของเรา ดำเนินการวิจัย และเพื่อวัตถุประสงค์ที่คล้ายกัน . นอกจากนี้ เราอาจวิเคราะห์พฤติกรรมทั่วไปและลักษณะเฉพาะของผู้ใช้บริการของเรา และแบ่งปันข้อมูลที่รวบรวมกับบุคคลที่สาม เผยแพร่ข้อมูลที่รวบรวมดังกล่าว หรือทำให้ข้อมูลดังกล่าวเข้าถึงได้โดยทั่วไป เราอาจรวบรวมข้อมูลรวมผ่านบริการ ผ่านคุกกี้ และผ่านวิธีการอื่นที่อธิบายไว้ในนโยบายความเป็นส่วนตัวนี้ เราจะรักษาและใช้ข้อมูลที่ไม่ระบุตัวตนในรูปแบบที่ไม่ระบุตัวตนหรือไม่ระบุตัวตน และเราจะไม่พยายามระบุข้อมูลดังกล่าวอีกครั้ง เว้นแต่กฎหมายกำหนด',
    block7:
      'ในบางกรณี เราอาจให้ข้อมูลส่วนบุคคลของคุณแก่บุคคลที่สามโดยไม่ต้องแจ้งให้คุณทราบเพิ่มเติม เว้นแต่กฎหมายกำหนด:',
    block8:
      'ขึ้นอยู่กับที่ตั้งทางภูมิศาสตร์ของคุณ บุคคลในเขตเศรษฐกิจยุโรป สหราชอาณาจักร และทั่วโลกอาจมีสิทธิ์ตามกฎหมายบางประการเกี่ยวกับข้อมูลส่วนบุคคลของตน ตัวอย่างเช่น คุณอาจมีสิทธิ์ที่จะ:',
    block9:
      'บริการอาจมีลิงก์ไปยังเว็บไซต์อื่นที่ไม่ได้ดำเนินการหรือควบคุมโดย Noam รวมถึงบริการโซเชียลมีเดีย ("เว็บไซต์บุคคลที่สาม") ข้อมูลที่คุณแบ่งปันกับเว็บไซต์บุคคลที่สามจะอยู่ภายใต้นโยบายความเป็นส่วนตัวและข้อกำหนดในการให้บริการเฉพาะของเว็บไซต์บุคคลที่สาม ไม่ใช่นโยบายความเป็นส่วนตัวนี้ เราจัดให้มีลิงก์เหล่านี้เพื่อความสะดวกและไม่ได้หมายความถึงการรับรองหรือการตรวจทานเว็บไซต์เหล่านี้ของเรา โปรดติดต่อเว็บไซต์บุคคลที่สามโดยตรงเพื่อขอข้อมูลเกี่ยวกับนโยบายความเป็นส่วนตัวและข้อกำหนด',
    subBlock1:
      'ข้อมูลบัญชี: เมื่อคุณสร้างบัญชีบนแพลตฟอร์มของเรา เราจะรวบรวมข้อมูลที่เกี่ยวข้องกับบัญชีของคุณ รวมถึงชื่อ ข้อมูลติดต่อ ข้อมูลรับรองบัญชี ข้อมูลบัตรชำระเงิน และประวัติการทำธุรกรรม ("ข้อมูลบัญชี")',
    subBlock10: 'การจัดหา การจัดการ การบำรุงรักษา และ/หรือการวิเคราะห์บริการ',
    subBlock11: 'สื่อสารกับคุณ;',
    subBlock12: 'การพัฒนาผลิตภัณฑ์และบริการใหม่',
    subBlock13:
      'การป้องกันการฉ้อโกง กิจกรรมทางอาญา หรือการใช้บริการของเราในทางที่ผิด และปกป้องความปลอดภัยของระบบไอที สถาปัตยกรรม และเครือข่ายของเรา',
    subBlock14: 'การดำเนินการถ่ายโอนธุรกิจ',
    subBlock15:
      'ปฏิบัติตามภาระผูกพันทางกฎหมายและการดำเนินคดี ปกป้องสิทธิ์ ความเป็นส่วนตัว ความปลอดภัย หรือทรัพย์สินของเรา เช่นเดียวกับของบริษัทในเครือของเรา คุณ หรือบุคคลที่สามอื่น ๆ',
    subBlock16:
      'ซัพพลายเออร์และผู้ให้บริการ: เพื่อช่วยเราในการตอบสนองความต้องการในการดำเนินธุรกิจและการให้บริการและฟังก์ชั่นบางอย่าง เราอาจให้ข้อมูลส่วนบุคคลแก่ซัพพลายเออร์และผู้ให้บริการ รวมถึงผู้ให้บริการโฮสต์ ผู้ให้บริการคลาวด์ และผู้ให้บริการเทคโนโลยีสารสนเทศอื่น ๆ ซอฟต์แวร์การสื่อสารทางอีเมล และผู้ให้บริการวิเคราะห์เว็บ ฯลฯ พันธมิตรเหล่านี้จะเข้าถึง ประมวลผล หรือจัดเก็บข้อมูลส่วนบุคคลตามคำสั่งของเราในขณะที่ปฏิบัติหน้าที่แทนเราเท่านั้น',
    subBlock17:
      'การโอนธุรกิจ: หากเรามีส่วนร่วมในธุรกรรมเชิงกลยุทธ์ การปรับโครงสร้างองค์กร การล้มละลาย การเทคโอเวอร์การล้มละลาย หรือการเปลี่ยนบริการไปยังผู้ให้บริการรายอื่น (เรียกรวมกันว่า "ธุรกรรม") ข้อมูลส่วนบุคคลและข้อมูลอื่น ๆ ของคุณอาจถูกแบ่งปันกับคู่ธุรกรรมและฝ่ายอื่น ๆ ที่ช่วยเหลือในการทำธุรกรรม ในระหว่างการตรวจสอบสถานะและโอนเป็นส่วนหนึ่งของธุรกรรมพร้อมกับสินทรัพย์อื่น ๆ ให้กับผู้สืบทอดหรือบริษัทในเครือ',
    subBlock18:
      'ข้อกำหนดทางกฎหมาย: เราอาจแบ่งปันข้อมูลส่วนบุคคลของคุณกับหน่วยงานของรัฐ เพื่อนร่วมงานในอุตสาหกรรม หรือบุคคลที่สามอื่น ๆ รวมถึงข้อมูลปฏิสัมพันธ์ของคุณกับบริการของเรา (1) หากกฎหมายกำหนด หรือหากเราเชื่อว่าการกระทำดังกล่าวจำเป็นต่อการปฏิบัติตามภาระผูกพันทางกฎหมาย (2) เพื่อปกป้องและปกป้องสิทธิหรือทรัพย์สินของเรา (3) หากเราพิจารณาเพียงฝ่ายเดียวว่ามีการละเมิดข้อกำหนด นโยบาย หรือกฎหมายของเรา (4) เพื่อตรวจจับหรือป้องกันการฉ้อโกงหรือกิจกรรมที่ผิดกฎหมายอื่น ๆ (5) เพื่อปกป้องผลิตภัณฑ์ พนักงาน หรือผู้ใช้ของเรา หรือความปลอดภัยสาธารณะ การรักษาความปลอดภัย ความซื่อสัตย์ หรือ (vi) เพื่อป้องกันความรับผิดทางกฎหมาย',
    subBlock19: 'เข้าถึงข้อมูลส่วนบุคคลของคุณและข้อมูลเกี่ยวกับวิธีการประมวลผล',
    subBlock2:
      'เนื้อหาผู้ใช้: เมื่อคุณใช้บริการของเรา เราจะรวบรวมข้อมูลส่วนบุคคลจากข้อมูลที่คุณป้อน การอัปโหลดไฟล์ หรือข้อเสนอแนะที่คุณให้ไว้กับเรา ("เนื้อหา")',
    subBlock20: 'ขอให้ลบข้อมูลส่วนบุคคลของคุณออกจากบันทึกของเรา',
    subBlock21: 'แก้ไขหรืออัพเดตข้อมูลส่วนบุคคลของคุณ',
    subBlock22: 'ถ่ายโอนข้อมูลส่วนบุคคลของคุณไปยังบุคคลที่สาม (การเคลื่อนย้ายข้อมูล)',
    subBlock23: 'จำกัดวิธีที่เราประมวลผลข้อมูลส่วนบุคคลของคุณ',
    subBlock24:
      'เพิกถอนความยินยอมของคุณ—ในกรณีที่เราอาศัยความยินยอมเป็นพื้นฐานทางกฎหมายในการประมวลผล คุณสามารถเพิกถอนความยินยอมของคุณได้ตลอดเวลา',
    subBlock25: 'คัดค้านวิธีที่เราประมวลผลข้อมูลส่วนบุคคลของคุณ',
    subBlock26: 'การปรับปรุงบริการของเราและการดำเนินการวิจัย',
    subBlock3:
      'ข้อมูลการสื่อสาร: หากคุณส่งข้อความถึงเรา เราจะรวบรวมชื่อ ข้อมูลติดต่อ และเนื้อหาข้อความของคุณ ("ข้อมูลการสื่อสาร")',
    subBlock4:
      'ข้อมูลโซเชียลมีเดีย: เรามีเพจบนเว็บไซต์โซเชียลมีเดีย เช่น Instagram, Facebook, Medium, Twitter, YouTube และ LinkedIn เมื่อคุณโต้ตอบกับหน้าโซเชียลมีเดียของเรา เราจะรวบรวมข้อมูลส่วนบุคคลที่คุณเลือกที่จะมอบให้เรา เช่น รายละเอียดการติดต่อของคุณ ("ข้อมูลโซเชียล") นอกจากนี้ บริษัทที่โฮสต์หน้าโซเชียลมีเดียของเราอาจให้ข้อมูลรวมและการวิเคราะห์เกี่ยวกับกิจกรรมโซเชียลมีเดียของเรา',
    subBlock5:
      'ข้อมูลบันทึก: ข้อมูลที่เบราว์เซอร์ของคุณส่งโดยอัตโนมัติเมื่อใช้บริการของเรา ข้อมูลบันทึกประกอบด้วยที่อยู่อินเทอร์เน็ตโปรโตคอล (IP) ของคุณ ประเภทเบราว์เซอร์และการตั้งค่า วันที่และเวลาที่คุณร้องขอ และวิธีที่คุณโต้ตอบกับเว็บไซต์ของเรา',
    subBlock6:
      'ข้อมูลการใช้งาน: เราอาจรวบรวมข้อมูลเกี่ยวกับการใช้บริการของคุณโดยอัตโนมัติ เช่น ประเภทของเนื้อหาที่คุณดูหรือโต้ตอบด้วย คุณสมบัติที่คุณใช้ การกระทำที่คุณทำ ตลอดจนโซนเวลา ประเทศ วันที่และเวลาของคุณ การเข้าถึง ตัวแทนผู้ใช้และเวอร์ชัน ประเภทคอมพิวเตอร์หรืออุปกรณ์เคลื่อนที่ และการเชื่อมต่อคอมพิวเตอร์ของคุณ',
    subBlock7:
      'ข้อมูลอุปกรณ์: รวมถึงชื่ออุปกรณ์ ระบบปฏิบัติการ ตัวระบุอุปกรณ์ และเบราว์เซอร์ที่คุณใช้ ข้อมูลที่รวบรวมอาจขึ้นอยู่กับประเภทของอุปกรณ์ที่คุณใช้และการตั้งค่า',
    subBlock8:
      'คุกกี้: เราใช้คุกกี้เพื่อดำเนินการและจัดการบริการของเรา และปรับปรุงประสบการณ์ของคุณ "คุกกี้" คือข้อมูลที่เว็บไซต์ที่คุณเยี่ยมชมส่งไปยังเบราว์เซอร์ของคุณ คุณสามารถตั้งค่าเบราว์เซอร์ของคุณให้ยอมรับคุกกี้ทั้งหมด ปฏิเสธคุกกี้ทั้งหมด หรือแจ้งให้คุณทราบเมื่อมีการให้คุกกี้ เพื่อให้คุณสามารถตัดสินใจว่าจะยอมรับคุกกี้ในแต่ละครั้งหรือไม่ อย่างไรก็ตาม การปฏิเสธคุกกี้อาจทำให้คุณไม่สามารถใช้งานหรือส่งผลเสียต่อการแสดงผลหรือการทำงานของพื้นที่หรือคุณลักษณะบางอย่างของเว็บไซต์ สำหรับข้อมูลเพิ่มเติมเกี่ยวกับคุกกี้ โปรดไปที่ All About Cookies',
    subBlock9:
      'การวิเคราะห์: เราอาจใช้ผลิตภัณฑ์การวิเคราะห์ออนไลน์ต่างๆ ที่ใช้คุกกี้เพื่อช่วยเราวิเคราะห์วิธีที่ผู้ใช้ใช้บริการของเรา และปรับปรุงประสบการณ์ของคุณเมื่อใช้บริการ',
    subTitle1: 'ข้อมูลส่วนบุคคลที่เรารวบรวม',
    subTitle2: 'วิธีที่เราใช้ข้อมูลส่วนบุคคล',
    subTitle3: 'การเปิดเผยข้อมูลส่วนบุคคล',
    subTitle4: 'สิทธิของคุณ',
    subTitle5: 'ลิงค์ไปยังเว็บไซต์อื่น',
    subTitle6: 'การรักษาความปลอดภัยและการเก็บรักษาข้อมูล',
    subTitle7: 'การปรับเปลี่ยนนโยบายความเป็นส่วนตัว',
    subTitle8: 'วิธีการติดต่อเรา',
    title: 'นโยบายความเป็นส่วนตัว',
    updateTime: 'อัปเดต: 15 มีนาคม 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'ยอมรับทั้งหมด',
    text: 'เพื่อปรับปรุงประสบการณ์ของคุณ เราใช้คุกกี้เพื่อปรับแต่งเนื้อหาและบริการในแบบของคุณ',
    title: 'เว็บไซต์นี้ใช้คุกกี้',
  },
  slogen: 'ผู้ช่วย AI ที่ง่ายที่สุด',
  stripe: {
    contact: 'ติดต่อเราได้ที่ contact@noam.tools หากมีคำถามใดๆ!',
    fail: {
      btn: 'ลองอีกครั้ง',
      text1: 'เราไม่สามารถประมวลผลการชำระเงินของคุณได้',
      text2: 'ตรวจสอบการเชื่อมต่อของคุณแล้วลองอีกครั้ง',
      title: 'การชำระเงินล้มเหลว',
    },
    succ: {
      btn: 'ไปกันเถอะ',
      text1: 'ยินดีต้อนรับสู่โนอาม',
      text2: 'มาเริ่มกันเลย!',
      title: 'ยินดีด้วย',
    },
  },
  terms: {
    block1: 'ขอบคุณที่ใช้โนม!',
    block10:
      '(ก) ค่าธรรมเนียมและการเรียกเก็บเงิน คุณจะต้องชำระค่าธรรมเนียมทั้งหมด ("ค่าธรรมเนียม") ตามราคาและเงื่อนไขในหน้าราคาที่เกี่ยวข้องหรือตามที่ตกลงเป็นลายลักษณ์อักษรระหว่างเรา เราขอสงวนสิทธิ์ในการแก้ไขข้อผิดพลาดหรือข้อผิดพลาดด้านราคา แม้ว่าเราจะออกใบแจ้งหนี้หรือได้รับการชำระเงินแล้วก็ตาม คุณจะให้ข้อมูลการเรียกเก็บเงินที่ครบถ้วนและถูกต้อง รวมถึงวิธีการชำระเงินที่ถูกต้องและได้รับอนุญาต เราจะเรียกเก็บเงินจากวิธีการชำระเงินของคุณเป็นระยะตามที่ตกลงไว้ แต่เราอาจเปลี่ยนแปลงวันที่เรียกเก็บเงินตามสมควร คุณอนุญาตให้ Noam บริษัทในเครือ และผู้ประมวลผลการชำระเงินบุคคลที่สามเรียกเก็บเงินจากวิธีการชำระเงินของคุณ หากการชำระเงินของคุณล้มเหลว เราจะแจ้งให้คุณทราบเป็นลายลักษณ์อักษรและอาจระงับการเข้าถึงบริการจนกว่าจะได้รับการชำระเงิน ยกเว้นจะระบุไว้เป็นอย่างอื่นในข้อตกลงนี้ การชำระเงินไม่สามารถขอคืนเงินได้',
    block11:
      '(ข) ภาษี เว้นแต่จะระบุไว้เป็นอย่างอื่น ค่าธรรมเนียมจะไม่รวมภาษี อากร และการประเมินที่คล้ายกัน ("ภาษี") ของรัฐบาลกลาง รัฐ ท้องถิ่น และต่างประเทศ คุณต้องรับผิดชอบภาษีทั้งหมดที่เกี่ยวข้องกับการซื้อของคุณ ไม่รวมภาษีตามรายได้สุทธิของเราที่เราจะออกใบแจ้งหนี้ให้กับคุณ คุณตกลงที่จะชำระภาษีดังกล่าวทันทีและมอบคำชี้แจงความเป็นส่วนตัวที่ถูกต้องตามกฎหมายแก่เรา และรับความยินยอมที่จำเป็นสำหรับการจัดการข้อมูลดังกล่าว และคุณรับประกันกับเราว่าคุณจัดการข้อมูลดังกล่าวตามกฎหมายที่บังคับใช้',
    block12:
      '(ค) การเปลี่ยนแปลงราคา เราอาจเปลี่ยนแปลงราคาของเราโดยแจ้งให้คุณทราบผ่านบัญชีของคุณและ/หรือเว็บไซต์ของเรา การขึ้นราคาจะมีผลทันทีเมื่อโพสต์ การเปลี่ยนแปลงราคาใด ๆ จะมีผลกับค่าธรรมเนียมสำหรับบัญชีของคุณหลังจากวันที่การเปลี่ยนแปลงมีผล',
    block13:
      '(ง) ข้อพิพาทและการชำระเงินที่ค้างชำระ หากคุณต้องการโต้แย้งค่าธรรมเนียมหรือภาษีใดๆ โปรดติดต่อ contact@noam.tools ภายในสามสิบ (30) วันนับจากวันที่ในใบแจ้งหนี้',
    block14:
      '(e) การใช้งานฟรี คุณไม่สามารถสร้างหลายบัญชีเพื่อรับเครดิตฟรี หากเราพิจารณาแล้วว่าคุณไม่ได้ใช้เครดิตฟรีโดยสุจริต เราอาจเรียกเก็บค่าธรรมเนียมมาตรฐานหรือหยุดให้บริการในการเข้าถึงบริการ',
    block15:
      '(ก) การรักษาความลับ คุณอาจสามารถเข้าถึงข้อมูลที่เป็นความลับของโนม คุณสามารถใช้ข้อมูลที่เป็นความลับตามที่ได้รับอนุญาตภายใต้ข้อกำหนดเหล่านี้เพื่อวัตถุประสงค์ในการใช้บริการเท่านั้น คุณไม่สามารถเปิดเผยข้อมูลที่เป็นความลับแก่บุคคลที่สามได้ และคุณจะปกป้องข้อมูลที่เป็นความลับในลักษณะที่มีการป้องกันไม่น้อยไปกว่าที่คุณปกป้องข้อมูลที่เป็นความลับที่คล้ายกันของคุณเอง อย่างน้อยก็ด้วยความระมัดระวังตามสมควร ข้อมูลที่เป็นความลับคือข้อมูลที่ไม่เปิดเผยต่อสาธารณะซึ่ง Noam กำหนดให้เป็นความลับ หรือที่ควรได้รับการปฏิบัติอย่างสมเหตุสมผลว่าเป็นความลับภายใต้สถานการณ์ รวมถึงซอฟต์แวร์ ข้อมูลจำเพาะ และข้อมูลทางธุรกิจอื่น ๆ ที่ไม่เปิดเผยต่อสาธารณะ ข้อมูลที่เป็นความลับไม่รวมถึงข้อมูลที่: (1) เปิดเผยต่อสาธารณะโดยทั่วไปโดยปราศจากความผิดในส่วนของคุณ; (2) คุณครอบครองโดยไม่มีภาระผูกพันในการรักษาความลับก่อนที่จะได้รับภายใต้ข้อกำหนดเหล่านี้ (3) ได้รับการเปิดเผยต่อคุณอย่างถูกต้องตามกฎหมายโดยบุคคลที่สามโดยไม่มีภาระผูกพันในการรักษาความลับใด ๆ หรือ (4) ได้รับการพัฒนาอย่างอิสระโดยคุณโดยไม่ต้องใช้ข้อมูลที่เป็นความลับ คุณสามารถเปิดเผยข้อมูลที่เป็นความลับได้หากกฎหมาย ศาล หรือคำสั่งของรัฐบาลกำหนด แต่คุณต้องแจ้งเป็นลายลักษณ์อักษรล่วงหน้าแก่ Noam ในลักษณะที่สมเหตุสมผล และพยายามตามสมควรเพื่อจำกัดขอบเขตของการเปิดเผยข้อมูล รวมถึงช่วยเหลือเรา เท่าที่เป็นไปได้ ในการคัดค้านการร้องขอการเปิดเผยข้อมูล',
    block16:
      '(ข) การรักษาความปลอดภัย คุณต้องใช้มาตรการที่สมเหตุสมผลและเหมาะสมเพื่อช่วยปกป้องการเข้าถึงและการใช้บริการของคุณ หากคุณพบช่องโหว่หรือการละเมิดใด ๆ ที่เกี่ยวข้องกับการใช้บริการของคุณ คุณต้องติดต่อ Noam โดยทันทีและแจ้งรายละเอียดเกี่ยวกับช่องโหว่หรือการละเมิดดังกล่าว',
    block17:
      '((c) การประมวลผลข้อมูลส่วนบุคคล หากคุณใช้บริการเพื่อประมวลผลข้อมูลส่วนบุคคล คุณต้องจัดทำคำชี้แจงความเป็นส่วนตัวที่เพียงพอตามกฎหมาย และได้รับความยินยอมที่จำเป็นสำหรับการประมวลผลข้อมูลดังกล่าว และคุณรับประกันต่อเราว่าคุณจัดการข้อมูลดังกล่าวตามกฎหมายที่บังคับใช้ .',
    block18:
      '(ก) การสิ้นสุด; ระบบกันสะเทือน ข้อกำหนดเหล่านี้จะมีผลตั้งแต่การใช้บริการครั้งแรกของคุณและจะมีผลบังคับจนกว่าจะยุติลง คุณสามารถยกเลิกข้อกำหนดเหล่านี้ได้ตลอดเวลาด้วยเหตุผลใดก็ได้โดยการหยุดใช้บริการและเนื้อหา เราอาจยกเลิกข้อกำหนดเหล่านี้โดยแจ้งให้ทราบล่วงหน้าด้วยเหตุผลใดก็ตาม เราอาจยุติข้อกำหนดเหล่านี้ทันทีโดยแจ้งให้คุณทราบหากคุณฝ่าฝืนส่วนที่ 2 (ข้อกำหนดการใช้งาน) ส่วนที่ 5 (การรักษาความลับ ความปลอดภัย และการปกป้องข้อมูล) ส่วนที่ 8 (การระงับข้อพิพาท) หรือส่วนที่ 9 (ข้อกำหนดทั่วไป) อย่างเป็นรูปธรรม หรือหากเรา ความสัมพันธ์กับผู้ให้บริการเทคโนโลยีบุคคลที่สามที่อยู่นอกเหนือการควบคุมของเรา การเปลี่ยนแปลงหรือเพื่อการปฏิบัติตามกฎหมายหรือคำขอของรัฐบาล เราอาจระงับการเข้าถึงบริการของคุณหากคุณไม่ปฏิบัติตามข้อกำหนดเหล่านี้ หรือหากการใช้งานของคุณก่อให้เกิดความเสี่ยงด้านความปลอดภัยต่อเราหรือบุคคลที่สาม หรือหากเราสงสัยว่าการใช้งานของคุณเป็นการฉ้อโกงหรืออาจทำให้เราหรือบุคคลที่สามต้องรับผิด .',
    block19:
      '(b) ผลของการยกเลิก เมื่อสิ้นสุด คุณจะหยุดใช้บริการและส่งคืนหรือทำลายข้อมูลที่เป็นความลับใด ๆ ทันทีตามที่เรากำหนด บทบัญญัติของข้อกำหนดเหล่านี้ซึ่งโดยธรรมชาติแล้วควรจะคงอยู่ต่อไปแม้ว่าจะมีการยกเลิกหรือการหมดอายุ รวมถึงแต่ไม่จำกัดเพียงส่วนที่ 3 และ 5-9 จะยังคงมีผลบังคับใช้ต่อไป',
    block2:
      'ข้อกำหนดการใช้งานเหล่านี้ใช้กับการใช้บริการของ Noam ของคุณ รวมถึงอินเทอร์เฟซการเขียนโปรแกรมแอปพลิเคชัน ซอฟต์แวร์ เครื่องมือ บริการสำหรับนักพัฒนา ข้อมูล เอกสารประกอบ และเว็บไซต์ (เรียกรวมกันว่า "บริการ") การใช้บริการของเราแสดงว่าคุณตกลงที่จะปฏิบัติตามข้อกำหนดเหล่านี้ นโยบายความเป็นส่วนตัวของเราอธิบายถึงวิธีที่เรารวบรวมและใช้ข้อมูลส่วนบุคคล',
    block20:
      '(ก) การชดใช้ค่าเสียหาย คุณจะปกป้อง ชดใช้ค่าเสียหาย และให้เรา บริษัทในเครือของเรา และบุคลากรของเราพ้นจากและต่อการเรียกร้อง ความสูญเสีย และค่าใช้จ่ายใดๆ (รวมถึงค่าทนายความ) ที่เกิดขึ้นจากหรือเกี่ยวข้องกับการใช้บริการของคุณ รวมถึงเนื้อหาของคุณ ของคุณ การใช้ผลิตภัณฑ์หรือบริการที่เกี่ยวข้องกับบริการ และการละเมิดข้อกำหนดเหล่านี้หรือกฎหมายที่บังคับใช้',
    block21:
      '(ข) การปฏิเสธความรับผิดชอบ บริการนี้มีให้ "ตามที่เป็น" ภายในขอบเขตที่กฎหมายอนุญาต เราและบริษัทในเครือและผู้อนุญาตของเราไม่ได้ให้การรับรองหรือรับประกันใด ๆ เกี่ยวกับบริการ และไม่รับประกัน รวมถึงแต่ไม่จำกัดเพียงการรับประกันความสามารถเชิงพาณิชย์ ความเหมาะสมสำหรับวัตถุประสงค์เฉพาะ คุณภาพที่น่าพอใจ การไม่ละเมิด และความบันเทิงอย่างเงียบๆ และการรับประกันใด ๆ ที่เกิดขึ้นจากการซื้อขายหรือการใช้งานทางการค้า เราไม่รับประกันว่าบริการจะไม่หยุดชะงัก แม่นยำ หรือปราศจากข้อผิดพลาด หรือเนื้อหาใดๆ จะปลอดภัย ไม่สูญหาย หรือไม่เปลี่ยนแปลง',
    block22:
      '(c) ข้อจำกัดความรับผิด ทั้งเรา บริษัทในเครือของเรา และผู้อนุญาตของเราจะไม่รับผิดชอบต่อความเสียหายทางอ้อม ความเสียหายพิเศษ เป็นผลสืบเนื่อง หรือการลงโทษ รวมถึงการสูญเสียผลกำไร การสูญเสียชื่อเสียง การสูญเสียการใช้งาน การสูญเสียข้อมูล หรือการสูญเสียที่ไม่สามารถจับต้องได้อื่น ๆ แม้ว่า เราได้รับแจ้งถึงความเป็นไปได้ที่จะเกิดความเสียหายดังกล่าวแล้ว ภายใต้ข้อกำหนดเหล่านี้ ความรับผิดทั้งหมดของเราจะไม่เกินค่าธรรมเนียมที่คุณจ่ายให้กับบริการในช่วงสิบสอง (12) เดือนก่อนการเรียกร้องหรือหนึ่งร้อยดอลลาร์สหรัฐ ($100) แล้วแต่จำนวนใดจะมากกว่า ข้อจำกัดในส่วนนี้ใช้กับขอบเขตสูงสุดที่กฎหมายที่ใช้บังคับอนุญาต',
    block23:
      'ข้อกำหนดและการใช้บริการของคุณอยู่ภายใต้กฎหมายของสหรัฐอเมริกา ยกเว้นกฎความขัดแย้งของกฎหมายของสหรัฐอเมริกา การใช้แอปพลิเคชันของคุณอาจอยู่ภายใต้กฎหมายท้องถิ่น รัฐ ประเทศ หรือระหว่างประเทศอื่นๆ การดำเนินการทางกฎหมายหรือการดำเนินการใด ๆ ที่เกี่ยวข้องกับข้อกำหนดเหล่านี้จะถูกนำขึ้นศาลของสหรัฐอเมริกาเท่านั้น และคุณตกลงที่จะอยู่ภายใต้เขตอำนาจศาลส่วนบุคคลของศาลดังกล่าว',
    block24:
      '(ก) ความสัมพันธ์ของคู่สัญญาทั้งสองฝ่าย Noam และคุณเป็นผู้รับจ้างอิสระ และไม่มีฝ่ายใดมีอำนาจในการเป็นตัวแทนหรือผูกมัดอีกฝ่ายหรือรับภาระผูกพันสำหรับอีกฝ่ายโดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจากอีกฝ่าย',
    block25:
      '(ข) การใช้แบรนด์ คุณไม่สามารถใช้ชื่อ โลโก้ หรือเครื่องหมายการค้าของ Noam หรือบริษัทในเครือใดๆ โดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรจากเราล่วงหน้า',
    block26:
      'หากข้อกำหนดใดๆ ของข้อกำหนดเหล่านี้ได้รับการพิจารณาว่าไม่ถูกต้อง ผิดกฎหมาย หรือไม่สามารถบังคับใช้ได้ ข้อกำหนดที่เหลือจะยังคงมีผลใช้บังคับอย่างสมบูรณ์',
    block3:
      'หากคุณอายุต่ำกว่า 18 ปี คุณต้องได้รับอนุญาตจากพ่อแม่หรือผู้ปกครองตามกฎหมายจึงจะใช้บริการได้ หากคุณกำลังใช้บริการในนามของบุคคลหรือนิติบุคคลอื่น คุณต้องได้รับอนุญาตให้ยอมรับข้อกำหนดเหล่านี้ในนามของพวกเขา คุณต้องให้ข้อมูลที่ถูกต้องและครบถ้วนเพื่อลงทะเบียนบัญชี คุณไม่สามารถให้ข้อมูลรับรองการเข้าถึงหรือบัญชีของคุณแก่บุคคลภายนอกองค์กรของคุณได้ และคุณต้องรับผิดชอบต่อกิจกรรมทั้งหมดที่ดำเนินการโดยใช้ข้อมูลประจำตัวของคุณ',
    block4:
      '(ก) การใช้บริการ คุณสามารถเข้าถึงบริการได้ภายใต้ข้อกำหนดเหล่านี้ และเราให้สิทธิ์ที่ไม่ผูกขาดแก่คุณในการใช้บริการ เมื่อใช้บริการ คุณจะต้องปฏิบัติตามข้อกำหนดเหล่านี้และกฎหมายที่บังคับใช้ทั้งหมด เราและบริษัทในเครือของเราเป็นเจ้าของสิทธิ์ กรรมสิทธิ์ และผลประโยชน์ทั้งหมดในบริการ',
    block5:
      '(ข) ผลตอบรับ เรายินดีรับคำติชม ข้อคิดเห็น แนวคิด ข้อเสนอแนะ และการปรับปรุง หากคุณให้เนื้อหาดังกล่าว เราอาจใช้เนื้อหาดังกล่าวโดยไม่มีข้อจำกัดใดๆ และไม่มีการชดเชยใดๆ ให้กับคุณ',
    block6:
      '(ค) ข้อจำกัด คุณไม่สามารถ: (1) ใช้บริการในลักษณะที่เป็นการละเมิด ยักยอกหรือละเมิดสิทธิใด ๆ ของผู้อื่น; (2) ทำวิศวกรรมย้อนกลับ แยกส่วน แยกส่วน แปล หรือพยายามค้นหาซอร์สโค้ดหรือส่วนประกอบพื้นฐานของโมเดลบริการ อัลกอริธึม และระบบ (เว้นแต่กฎหมายที่บังคับใช้จะห้ามข้อจำกัดดังกล่าว) (3) ใช้ผลลัพธ์ของบริการเพื่อพัฒนาแบบจำลองที่แข่งขันกับ Noam (4) ดึงข้อมูลหรือเอาท์พุตจากบริการโดยใช้วิธีการอัตโนมัติหรือการเขียนโปรแกรมใดๆ เว้นแต่จะได้รับอนุญาตผ่าน API รวมถึงการขูด การเก็บเกี่ยวเว็บ หรือการดึงข้อมูลเว็บ (5) นำเสนอผลลัพธ์ของบริการว่าสร้างขึ้นปลอมเมื่อไม่ได้เกิดขึ้น หรือฝ่าฝืนนโยบายการใช้งานของเรา (6) ซื้อ ขาย หรือโอนคีย์ API โดยไม่ได้รับความยินยอมจากเราล่วงหน้า หรือ (7) ให้ข้อมูลส่วนบุคคลใด ๆ ของเด็กอายุต่ำกว่า 13 ปีหรืออายุที่ได้รับความยินยอมทางดิจิทัลแก่เรา คุณจะปฏิบัติตามขีดจำกัดอัตราและข้อกำหนดอื่นๆ ในเอกสารของเรา',
    block7:
      '(d) บริการของบุคคลที่สาม ซอฟต์แวร์ บริการ หรือผลิตภัณฑ์อื่นๆ ของบุคคลที่สามที่เกี่ยวข้องกับบริการอยู่ภายใต้ข้อกำหนดของตนเอง และเราจะไม่รับผิดชอบต่อผลิตภัณฑ์ของบุคคลที่สาม',
    block8:
      '(ก) เนื้อหาของคุณ คุณสามารถจัดเตรียมข้อมูลเข้า ("ข้อมูลเข้า") ให้กับบริการและรับข้อมูลออก ("ข้อมูลออก") ที่สร้างและส่งคืนตามข้อมูลเข้า (เรียกรวมกันว่า "เนื้อหา") ระหว่างคู่สัญญาทั้งสองฝ่าย และตามขอบเขตที่กฎหมายที่เกี่ยวข้องอนุญาต คุณเป็นเจ้าของข้อมูลนำเข้าทั้งหมด Noam อาจใช้เนื้อหาเพื่อให้บริการและบำรุงรักษาบริการ ปฏิบัติตามกฎหมายที่บังคับใช้ และบังคับใช้นโยบายของเรา คุณต้องรับผิดชอบต่อเนื้อหา รวมถึงตรวจสอบให้แน่ใจว่าเนื้อหานั้นไม่ละเมิดกฎหมายที่บังคับใช้หรือข้อกำหนดเหล่านี้',
    block9:
      '(ข) ความแม่นยำ ปัญญาประดิษฐ์และการเรียนรู้ของเครื่องกำลังพัฒนาอย่างรวดเร็วในด้านการวิจัย เราพยายามปรับปรุงบริการของเราอย่างต่อเนื่องเพื่อให้มีความแม่นยำ เชื่อถือได้ ปลอดภัย และเป็นประโยชน์มากขึ้น เมื่อพิจารณาถึงลักษณะความน่าจะเป็นของการเรียนรู้ของเครื่อง การใช้บริการของเราอาจส่งผลให้เกิดผลลัพธ์ที่ไม่ถูกต้องในบางกรณี ซึ่งอาจไม่สะท้อนถึงบุคคล สถานที่ หรือข้อเท็จจริงที่แท้จริงได้อย่างถูกต้อง คุณควรประเมินความถูกต้องของเอาต์พุตอย่างเหมาะสมตามกรณีการใช้งานของคุณ รวมถึงโดยการตรวจสอบผลลัพธ์ด้วยตนเอง',
    subTitle1: 'การลงทะเบียนและการเข้าถึง',
    subTitle10: 'ความเป็นโมฆะ',
    subTitle2: 'ข้อกำหนดการใช้งาน',
    subTitle3: 'เนื้อหา',
    subTitle4: 'ค่าธรรมเนียมและการชำระเงิน',
    subTitle5: 'การรักษาความลับ ความปลอดภัย และการปกป้องข้อมูล',
    subTitle6: 'ระยะเวลาและการสิ้นสุด',
    subTitle7: 'การชดใช้ค่าเสียหาย; ข้อสงวนสิทธิ์; ข้อจำกัดความรับผิด',
    subTitle8: 'กฎหมายที่ใช้บังคับและเขตอำนาจศาล',
    subTitle9: 'ข้อกำหนดทั่วไป',
    title: 'ข้อกำหนดในการให้บริการ',
    updateTime: 'อัปเดต: 15 มีนาคม 2024',
  },
  trialModal: {
    btn: 'เริ่มต้นเลย (เพียง $0.99)',
    chat: 'แชทPDF',
    desc1: 'หลังจากการทดลองใช้ คุณจะถูกเรียกเก็บค่าธรรมเนียมรายปีจำนวน 180 ดอลลาร์',
    desc2: 'ยกเลิกได้ตลอดเวลา',
    focus: 'การมุ่งเน้น',
    hover: 'เลื่อนการแปล',
    image: 'การแปลรูปภาพ',
    installBtn: 'ติดตั้งตอนนี้เพื่อรับของขวัญของคุณ',
    memo: 'การจัดการรายการโปรด',
    pdf: 'การแปล PDF แบบขนาน',
    realtime: 'การแปลทันที',
    select: 'การแปลการเลือกคำ',
    title: 'ของขวัญต้อนรับ',
    trialText: 'ทดลองใช้งาน 7 วัน',
    video: 'การแปลวิดีโอ',
    videoSummary: 'สรุปวิดีโอ',
    web: 'การแปลแบบขนาน',
    webSummary: 'สรุปเว็บ',
  },
  upgradeModal: {
    btn: 'อัพเกรดทันที',
    chat: {
      free: 'คุณมี ChatPDF ถึงขีดจำกัดแล้ว',
      pro: 'คุณมี ChatPDF ถึงขีดจำกัดของเดือนนี้แล้ว',
    },
    contactStr: 'โปรดรอการรีเซ็ตครั้งถัดไป หรือติดต่อเราที่ contact@noam.tools',
    limitAlertStr: 'คุณใช้แผนฟรีถึงขีดจำกัดแล้ว อัปเกรดเพื่อดำเนินการต่อ',
    more: 'ดูแผน',
    pageLimit: { free: 'คุณมีหน้า PDF ถึงขีดจำกัดแล้ว' },
    title: 'คำเตือน',
    upgradeAlertStr: 'คุณใช้แผนฟรีถึงขีดจำกัดแล้ว อัปเกรดเพื่อดำเนินการต่อ',
    upload: {
      free: 'คุณได้แปล PDF ถึงขีดจำกัดแล้ว',
      pro: 'คุณได้แปล PDF ถึงขีดจำกัดสำหรับเดือนนี้แล้ว',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'เข้าร่วมตอนนี้',
      label: 'ประโยชน์ของผู้ใช้ใหม่:',
      remain: 'เหลือเพียง 30 เท่านั้น',
      text: 'มีเพียง 100 ที่เท่านั้น! คว้าของคุณตอนนี้!',
    },
  },
}

export default TRANSLATION
